import { defineAction } from '~/prix'
import { z } from 'zod'
import semenProgramCreateAction from './semenProgramCreate.action.json' with { type: 'json' }
import { semenProgramObject } from '../semenProgramObject'

const semenProgramCreateDefinition = defineAction({
  ...semenProgramCreateAction,

  input: semenProgramObject
    .pick({ id: true, name: true, usageLimit: true, description: true, bullId: true })
    .partial({ id: true }),
  output: z.object({ id: semenProgramObject.shape.id }),
})

export default semenProgramCreateDefinition
